interface BackgroundAnimationProps {
  id: string;
}

export function BackgroundAnimation({ id }: BackgroundAnimationProps) {
  return (
    <div
      className="relative mt-6"
      id={id}
      style={{ display: "flex", justifyContent: "center" }}
    >
      <div className="absolute w-full max-w-[725px] h-auto Price_KV-1_G" id="Price_KV-1_G">
        <img
          src="/imgs/KV-1.png"
          alt="Live Your Best Lip!"
          className="w-full h-auto"
          id="Price_KV-1"
        />
      </div>
      <div className="absolute w-full max-w-[725px] h-auto Price_KV-1_G" id="Price_KV-1_G2">
        <img
          src="/imgs/KV-1B.png"
          alt="Live Your Best Lip!"
          className="w-full h-auto"
          id="Price_KV-1B"
        />
      </div>
      <div className="absolute w-full max-w-[725px] h-auto" id="Price_KV-2_G">
        <img
          src="/imgs/KV-2.png"
          alt="Live Your Best Lip!"
          className="absolute w-full h-auto"
          id="Price_KV-2"
        />
      </div>
      <div className="absolute w-full max-w-[725px] h-auto floating">
        <img
          src="/imgs/KV-3.png"
          alt="Live Your Best Lip!"
          className="absolute w-full h-auto"
          id="Price_KV-3"
        />
      </div>
      <div className="absolute w-full max-w-[725px] h-auto floating2">
        <img
          src="/imgs/KV-4.png"
          alt="Live Your Best Lip!"
          className="absolute w-full h-auto"
          id="Price_KV-4"
        />
      </div>
      <div className="absolute w-full max-w-[725px] h-[678px]" id="Price_KV-5_G">
        <img
          src="/imgs/KV-5.png"
          alt="Live Your Best Lip!"
          className="absolute w-full h-auto"
          id="Price_KV-5"
        />
      </div>
      <div className="absolute w-full max-w-[725px] h-[678px]" id="Price_KV-6-7_G">
        <img
          src="/imgs/KV-6.png"
          alt="Live Your Best Lip!"
          className="absolute w-full h-auto"
          id="Price_KV-6"
        />
        <img
          src="/imgs/KV-7.png"
          alt="Live Your Best Lip!"
          className="absolute w-full h-auto"
          id="Price_KV-7"
        />
      </div>
    </div>
  );
}